<template>
<div>
  <van-field :v-model="timeVmodel" required label-width="10rem" :name="timeName" :value="timeValue" placeholder="请选择" input-align="right" readonly right-icon="arrow" @click="showTime" :rules="[{ validator:validatorTime, message: '请选择'+timeLabel }]">
    <template #label>
      <span class="input-left-label-hq">{{timeLabel}}</span>
    </template>
  </van-field>

  <van-popup v-model="showTimeVmodel" position="bottom">
    <van-datetime-picker type="datetime" @cancel="onCancelDate" @confirm="onConfirmDate" :min-date="minDate" :max-date="maxDate" :formatter="formatter" />
  </van-popup>

</div>
</template>

<script>
import {
  Toast
} from 'vant';
export default {
  data() {
    const twoDaysTime = new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
    return {
      minDate: new Date(twoDaysTime),
      maxDate: new Date(),
      currentDate: new Date(),
      showTimeVmodel: false
    }
  },
  props: {
    timeVmodel: {
      type: String,
      default: ""
    },
    timeName: {
      type: String,
      default: ""
    },
    timeLabel: {
      type: String,
      default: ""
    },
    timeValue: {
      type: String,
      default: ""
    },
    timeRequire: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    validatorTime(val) {
      if (this.timeRequire) {
        if (!val) {
          Toast.fail('请填写' + this.timeLabel);
          return false;
        }

        if (val < this.currentDate) {
          Toast.fail('请选择' + this.timeLabel + '正确日期');
          return false;
        }
        return val;
      }
    },
    onConfirmDate() {
      var confirmDate = `${this.value1}-${this.value2}-${this.value3} ${this.value4}:${this.value5}`;

      this.$emit('getYxq', confirmDate)
      this.onCancelDate()
    },
    onCancelDate() {
      this.showTimeVmodel = false
    },
    showTime() {
      this.showTimeVmodel = true;
    },
    formatter(type, value) {
      if (type === 'year') {
        this.value1 = value // 可以拿到当前点击的数值
        return `${value}年`
      }
      if (type === 'month') {
        this.value2 = value
        return `${value}月`
      }
      if (type === 'day') {
        this.value3 = value
        return `${value}日`
      }
      if (type === 'hour') {
        this.value4 = value
        return `${value}时`
      }
      this.value5 = value
      return `${value}分`
    },

  },
}
</script>
<style lang="scss" scoped>
.by-red {
    color: red;
    padding: 0 3px;
    font-size: 14px;
}
</style>
